import { withT } from "neetocommons/react-utils";
import { Filters as NeetoFilters } from "neetofilters";
import { Filter } from "neetoicons";

const FilterButton = withT(({ t, buttonProps, ...props }) => (
  <div className="neeto-molecules-subheader__filter">
    <NeetoFilters
      buttonProps={{
        "data-testid": "filter-button",
        icon: Filter,
        style: "text",
        tooltipProps: {
          content: t("neetoMolecules.common.filter"),
          position: "bottom",
          touch: ["hold", 500],
        },
        label: null,
        ...buttonProps,
      }}
      {...props}
    />
  </div>
));

export default FilterButton;
